import { BaseDto } from './base.dto';

export class ProductBuilderDto extends BaseDto {
  productId: number;
  productStockId: number;
  preparationTime: number;
  unitQuantity: number;
  weightQuantity: number;
  totalCost: number;
}
